import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss']
})
export class ErrorPopupComponent implements OnInit {

  constructor(
    private dialog: MatDialogRef<ErrorPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public matData: any,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    console.log('err', this.matData);
  }

  searchAgain() {
    localStorage.removeItem('FlightLoginToken');
    const searchParam: any = JSON.parse(localStorage.getItem('flightSearchParams'));
    if(this.authService.loggedIn()) {
      this.router.navigate([`/u/flights/search/${searchParam.tourType}/${searchParam.bookingClass}/${searchParam.passengerDetail}/${searchParam.travelDetail}/${searchParam.deptDate}/${searchParam?.returnDate || ''}`]);
    } else {
      this.router.navigate([`../search/${searchParam.tourType}/${searchParam.bookingClass}/${searchParam.passengerDetail}/${searchParam.travelDetail}/${searchParam.deptDate}/${searchParam?.returnDate || ''}`]);
    }
    
    // const tripType = localStorage.getItem('tripType');
    // this.router.navigate(['../search'], { relativeTo: this.route, queryParams: { tripType: tripType, itinerary: searchParam } });
    this.dialog.close();
  }

}
